// extracted by mini-css-extract-plugin
export default {"root":"GeuSLzZz","formats":"ctgtkscd"};